import AmountButton from 'javascripts/components/DonateForm/AmountButton';
import AmountInputWithError from 'javascripts/components/AmountInputWithError';
import React from 'react';
import cx from 'classnames';
import store from 'javascripts/store.js';
import {observer} from 'mobx-react';
import {reaction} from 'mobx';

@observer
class DonateFormAmountButtons extends AmountInputWithError {
  constructor(props) {
    super(props);
    store.donateForm.amount = store.donateForm.buttonAmounts.highlight;

    reaction(
      () => store.donateForm.optimizelyParams,
      () => {
        store.donateForm.amount = store.donateForm.buttonAmounts.highlight;
      }
    );
  }

  handleOtherAmountButtonClick = () => {
    store.donateForm.amount = null;
    store.donateForm.showOtherAmountInput = true;
    setTimeout(() => {
      this.amountInput.focus();
    }, 1);
  };

  render () {
    const {
      maxAmount,
      readOnly,
    } = this.props;

    const {
      amount,
      campaignId,
      currencyName,
      currencyUnit,
      isSubscription,
      showOtherAmountInput,
    } = store.donateForm;

    return (
      <div>
        <div className='amount-wrapper'>
          <div className='amount-buttons-wrapper'>
            {store.donateForm.buttonAmounts.values.map(amount => (
              <AmountButton
                highlighted={(amount == store.donateForm.amount) && !showOtherAmountInput}
                key={amount}
                value={amount}
              />
            ))}

            <a
              className={cx('button button--grey-20 other-amount-button', {hidden: showOtherAmountInput})}
              onClick={this.handleOtherAmountButtonClick}
            >
              Other amount
            </a>
            <div
              className={cx(
                `input-wrapper lh donate-amount ${campaignId}`,
                {hidden: !showOtherAmountInput}
              )}
            >
              <label htmlFor='amount'>
                Donation Amount
              </label>
              <div className='input-field-container'>
                <span className='preinput'>{currencyUnit}</span>
                <input
                  data-amount='true'
                  data-parsley-currency={`${this.minimumAmount(isSubscription)},${maxAmount}`}
                  data-parsley-error-message={this.errorMsg(isSubscription, amount)}
                  data-parsley-errors-container={`.donate-amount.${campaignId} .error`}
                  name='amount'
                  onChange={e => store.donateForm.amount = parseFloat(e.target.value)}
                  placeholder='Other'
                  readOnly={readOnly}
                  ref={el => this.amountInput = el}
                  required='required'
                  step='0.01'
                  type='number'
                  value={amount || ''}
                />
                <span className='postinput'>
                  <span className='uppercase'>
                    {currencyName}
                  </span>
                  {isSubscription ? '/mo' : ''}
                </span>
              </div>
              <div className='error' />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DonateFormAmountButtons;
